import { render, staticRenderFns } from "./UserNotes.vue?vue&type=template&id=3468749b&"
import script from "./UserNotes.vue?vue&type=script&lang=js&"
export * from "./UserNotes.vue?vue&type=script&lang=js&"
import style0 from "./UserNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports